export const updateActiveMetric = (metricValue) => {
  return {
    type: 'ACTIVE_METRIC_UPDATE',
    payload: metricValue
  }
}
